<template>
  <v-card>
    <v-container fluid grid-list-xl>
      <v-progress-linear indeterminate color="primary" v-if="topLoading"></v-progress-linear>
      <span class="subtitle-1 font-weight-bold">{{$t('message.onedriveSettings.oneDriveSetup')}}</span>
      <v-layout wrap class="pa-3">
        <v-card-text class="pa-0">
         <v-form ref="urlReadForm">
            <v-row>
              <v-col cols="12" lg="4" md="4" sm="6" class="pb-0">
                <v-text-field dense v-model="modelObj.baseurl" hide-details :label="$t('message.sharepointSettings.baseUrl')" outlined :rules="$_requiredValidation"></v-text-field>
              </v-col>
              <v-col cols="12" lg="4" md="4" sm="6" class="pb-0">
                <v-text-field dense v-model="modelObj.siteurl" hide-details :label="$t('message.sharepointSettings.siteUrl')" outlined :rules="$_requiredValidation"></v-text-field>
              </v-col>
              <v-col cols="12" lg="3" md="4" sm="2" class="pb-0">
                <v-btn class="primary mx-1" @click="changeCurrentLoginUser" :loading="changeuserLoading"> {{ $t('message.sharepointSettings.changeUser') }} </v-btn>
                <v-btn color="error" class="mx-1" @click.stop="deleteConfirmationDialog=true">{{$t('message.common.delete')}}</v-btn>
              </v-col>
              <v-col cols="12" class="pa-0 mt-2 ml-3">
                <v-alert class="mb-0" dense type="info" outlined color="cyan" border="left">
                  {{ $t('message.sharepointSettings.sharepointAlertMsg', { userName: modelObj.userdisplayname || '' }) }}
                </v-alert>
              </v-col>
              <v-col cols="12" class="pa-0">
                <v-btn class="primary mt-3 ml-2" @click="getLoginInfo('loadList')" :loading="listLoading" v-if="modelObj.accesstoken">{{$t('message.sharepointSettings.loadList')}}</v-btn>
                <v-btn class="primary mt-3 ml-2" @click="redirectToSharepoint" :loading="listLoading" v-else>{{$t('message.layout.login')}}</v-btn>
              </v-col>
            </v-row>
         </v-form>
        </v-card-text>
      </v-layout>
      <template v-if="modelObj.accesstoken">
      <v-layout wrap class="pa-3 py-0 pt-0">
        <v-card-text class="pa-0">
         <v-form ref="loadListForm">
            <v-row>
              <v-col cols="12" lg="4" md="4" sm="6" class="pb-0">
                <v-select dense v-model="modelObj.list_name" hide-details :label="$t('message.sharepointSettings.listName')" outlined :rules="$_requiredValidation"
                  :items="listNames" item-text="name" item-value="id"></v-select>
              </v-col>
              <v-col cols="12" class="pa-0">
                <v-btn class="primary ma-3" @click="getLoginInfo('loadFolders')" :loading="rootFolderLoading">{{$t('message.sharepointSettings.loadFolders')}}</v-btn>
              </v-col>
            </v-row>
         </v-form>
        </v-card-text>
      </v-layout>
      <v-divider></v-divider>
      <v-layout wrap class="pa-3 py-0" v-if="rootFolders.length > 0 && !topLoading">
        <v-card-text class="pa-0">
        <v-form ref="idReadForm">
          <v-row>
            <v-col cols="12" class="pa-0">
              <v-divider></v-divider>
              <v-progress-linear indeterminate color="primary" v-if="folderLoading"></v-progress-linear>
            </v-col>
            <!-- <v-col cols="12" lg="4" md="4" sm="6" class="pb-0">
              <v-select dense v-model="modelObj.contenttype" hide-details :label="$t('message.sharepointSettings.contentType')" outlined
                :items="contentType" item-text="name" item-value="id" :rules="$_requiredValidation"></v-select>
            </v-col> -->
            <v-col cols="12" lg="4" md="4" sm="6" class="pb-0">
              <v-select dense  v-model="modelObj.hse_base_folder_id" :items="rootFolders" item-text="name" item-value="id" @change="getChildrenFolders" hide-details
                :label="$t('message.onedriveSettings.selectHse')" outlined :rules="$_requiredValidation"></v-select>
            </v-col>
            <v-col cols="12" lg="4" md="4" sm="6" class="pb-0" v-if="childrenFolders.length > 0">
              <v-select dense  v-model="modelObj.product_base_folder_id" :items="childrenFolders" item-text="name" item-value="id" hide-details :label="$t('message.onedriveSettings.selectProduct')"
                outlined :rules="$_requiredValidation"></v-select>
            </v-col>
            <v-col cols="12" lg="4" md="4" sm="6" class="pb-0" v-if="childrenFolders.length > 0">
              <v-select dense  v-model="modelObj.customer_base_folder_id" :items="childrenFolders" item-text="name" item-value="id" hide-details :label="$t('message.onedriveSettings.selectCustomer')"
                outlined :rules="$_requiredValidation"></v-select>
            </v-col>
            <v-col cols="12" lg="4" md="4" sm="6" class="pb-0" v-if="childrenFolders.length > 0">
              <v-select dense  v-model="modelObj.deviation_base_folder_id" :items="childrenFolders" item-text="name" item-value="id" hide-details :label="$t('message.onedriveSettings.selectDeviation')"
                outlined :rules="$_requiredValidation"></v-select>
            </v-col>
            <v-col cols="12" class="pa-0">
              <v-btn class="primary ma-3" :disabled="!childrenFolders.length > 0" :loading="saveLoading" @click="saveSetting()">
                {{ modelObj && modelObj.hse_base_folder_id ?$t('message.common.update') : $t('message.common.save') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
        </v-card-text>
      </v-layout>
      <v-divider></v-divider>
      <v-layout wrap class="pa-3 py-0">
        <span class="subtitle-1 font-weight-bold">{{$t('message.sharepointSettings.propertiesConfig')}}:</span>
        <v-card-text class="pa-0">
          <v-form ref="propertiesForm">
            <v-row>
              <v-col cols="12" class="pa-0">
                  <v-divider></v-divider>
                  <v-progress-linear indeterminate color="primary" v-if="propsLoading"></v-progress-linear>
                </v-col>
              <v-col class="pa-0 pl-2" cols="6" sm="4" md="3" lg="2" v-for="(options, index) in listOfProperties" :key="index">
                <v-checkbox hide-details color="primary" v-model="selectedProps" :label="options.title" :value="options.name" multiple></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pa-0">
                <v-btn class="primary ma-3" :loading="propActionLoading" @click="saveSelectedProps">{{ $t('message.common.update') }}</v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-layout>
    </template>
    <v-dialog v-model="deleteConfirmationDialog" max-width="500px">
      <v-form ref="confirmationForm" onsubmit="return false;">
        <v-card>
          <v-card-title>
            {{$t('message.sharepointSettings.config')}}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            {{$t('message.common.areYouSure')}}
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text class="pa-2 text-right">
            <v-btn color="primary" class="mx-1" :loading="deleteLoading" @click="deleteSharepointSetting">{{$t('message.common.yes')}}</v-btn>&nbsp;
            <v-btn color="error" class="mx-1"  @click.stop="deleteConfirmationDialog=false">{{$t('message.common.no')}}</v-btn>&nbsp;
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>
    </v-container>
  </v-card>
</template>
<script>
export default {
  data () {
    return {
      deleteConfirmationDialog: false,
      deleteLoading: false,
      topLoading: false,
      folderLoading: false,
      modelObj: {},
      MODULE_URL: 'sharepointsetting',
      rootFolders: [],
      contentType: [],
      listNames: [],
      rootFolderLoading: false,
      childrenFolders: [],
      saveLoading: false,
      isAlreadyConfigured: false,
      listOfProperties: [],
      selectedProps: [],
      propsLoading: false,
      propActionLoading: false,
      listLoading: false,
      loadType: '',
      showPassword: false,
      /* check with new baseurl&siteurl */
      clonedModelObj: {},
      changeuserLoading: false,
      userListNames: []
    }
  },
  mounted () {
    if (this.$route.query.code) {
      const baseurl = window.localStorage.getItem(process.env.VUE_APP_SHAREPOINTBASEURL)
      const siteurl = window.localStorage.getItem(process.env.VUE_APP_SHAREPOINTSITEURL)
      const code = this.$route.query.code
      const model = { baseurl, siteurl, code }
      this.$_executeApi('post', 'sharepointtoken/get_access_token_from_code', model).then(({ data }) => {
        const model = { baseurl, siteurl, accesstoken: data.accesstoken, siteid: data.site.id }
        this.modelObj = Object.assign({}, this.modelObj, model)
      })
    } else this.getSharepointSetting()
  },
  watch: {

  },
  methods: {
    deleteSharepointSetting () {
      this.deleteLoading = true
      this.$_executeApi('delete', 'sharepointsetting/0').then(response => {
        this.deleteConfirmationDialog = false
        this.deleteLoading = false
        this.getSharepointSetting()
      })
    },
    getAllFields () {
      this.propsLoading = true
      this.$_executeApi('get', `sharepoint/get_all_fields`)
        .then((response) => {
          this.listOfProperties = response.data || []
        })
        .finally(() => {
          this.propsLoading = false
        })
    },
    saveSelectedProps () {
      this.propActionLoading = true
      let model = this.modelObj
      model.properties = JSON.stringify(this.selectedProps)
      this.$_executeApi('post', `${this.MODULE_URL}`, model)
        .then((response) => {
          this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.savedSuccess') })
        })
        .finally(() => {
          this.propActionLoading = false
        })
    },
    getSharepointSetting () {
      this.topLoading = true
      this.$_executeApi('get', `${this.MODULE_URL}`).then((response) => {
        this.modelObj = response.data
        this.selectedProps = this.modelObj.properties ? JSON.parse(this.modelObj.properties) : null
        if (this.modelObj.accesstoken) {
          this.listLoading = true
          this.$_executeApi('post', `${this.MODULE_URL}/get_lists`, this.modelObj).then((response) => {
            if (response.data) {
              const { lists, userlists } = response.data
              this.listNames = lists
              this.userListNames = userlists
              if (this.modelObj.accesstoken) this.getLoginInfo('loadFolders')
            }
          }).finally(() => { this.listLoading = false })
        }
      }).finally(() => { this.topLoading = false })
    },
    getLoginInfo (type) {
      if (!this.modelObj.accesstoken) {
        this.loadType = type
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
      } else {
        if (type === 'loadList') this.loadList(true)
        else this.loadFolders(true)
      }
    },
    loadFolders (novalidation) {
      if (novalidation ? true : this.$refs.urlReadForm.validate()) {
        this.rootFolders = []
        this.rootFolderLoading = true
        const model = this.modelObj
        this.$_executeApi('post', `${this.MODULE_URL}/get_root_folders`, model).then(({ data }) => {
          this.rootFolders = data.rootfolders
          this.contentType = data.contenttypes ? data.contenttypes : []
          if (this.modelObj.hse_base_folder_id) this.getChildrenFolders()
        }).finally(() => { this.rootFolderLoading = false })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    loadList (novalidation) {
      if (novalidation ? true : this.$refs.urlReadForm.validate()) {
        this.rootFolders = []
        this.listLoading = true
        const model = this.modelObj
        this.$_executeApi('post', `${this.MODULE_URL}/get_lists`, model).then(({ data }) => {
          const { lists, userlists } = data
          this.listNames = lists
          this.userListNames = userlists
        }).finally(() => { this.listLoading = false })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    loadBasedOnType () {
      if (this.loadType === 'loadFolders') {
        this.loadFolders()
      } else {
        this.loadList()
      }
    },
    getChildrenFolders () {
      this.folderLoading = true
      const model = this.modelObj
      const result = []
      this.$_executeApi('post', `${this.MODULE_URL}/get_children_folders_and_fields`, model).then(({ data }) => {
        if (data.folders && data.folders.length > 0) this.childrenFolders = data.folders
        if (data.fields && data.fields.length > 0) this.listOfProperties = data.fields
        this.listOfProperties.forEach(options => { if (options.required && !options.readonly) result.push(options.name) })
      }).finally(() => { this.folderLoading = false })
      if (this.selectedProps && this.selectedProps.length < 0) this.selectedProps = result
    },
    saveSetting () {
      if (this.$refs.idReadForm.validate()) {
        this.saveLoading = true
        let model = this.modelObj
        this.$_executeApi('post', `${this.MODULE_URL}`, model)
          .then((response) => {
            if (response.data) {
              this.childrenFolders = response.data
              this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.savedSuccess') })
              this.getSharepointSetting()
            }
          })
          .finally(() => {
            this.saveLoading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    redirectToSharepoint () {
      if (this.modelObj.baseurl && this.modelObj.siteurl) {
        this.setStorage()
        this.$_executeApi('post', 'sharepointtoken/get_sharepoint_auth_url', this.modelObj).then(response => {
          if (response.data) {
            window.open(response.data.url, '_self')
          }
        })
      }
    },
    setStorage () {
      window.localStorage.setItem(process.env.VUE_APP_SHAREPOINTBASEURL, this.modelObj.baseurl)
      window.localStorage.setItem(process.env.VUE_APP_SHAREPOINTSITEURL, this.modelObj.siteurl)
    },
    changeCurrentLoginUser () {
      this.changeuserLoading = true
      this.loading = true
      this.$_executeApi('get', `${this.MODULE_URL}/change_access_refresh_token`).then(({ data }) => {
        if (data) {
          this.modelObj = { ...this.modelObj, ...data }
          this.saveSetting()
        }
      }).finally(() => { this.changeuserLoading = false })
    }
  }
}
</script>
